import React from 'react';
import {
  Box,
  Button,
  Media,
  Paper,
  Text,
  Truncate,
} from '@tenancy.nz/design-system';
import PropTypes from 'prop-types';
import StyledPropertyItem from './PropertyItem.styled';
import PropertyAttributes from './PropertyAttributes';

function PropertyCard({
  onView = null,
  photo = '',
  address = '',
  rentAmount = '',
  dateAvailable = '',
  bedrooms = null,
  bathrooms = null,
  parkingSpaces = null,
}) {
  return (
    <StyledPropertyItem onClick={onView}>
      <Paper>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'stretch',
            flexDirection: {xs: 'column', sm: 'row'},
          }}>
          <Box
            sx={{
              width: '100%',
              maxWidth: {xs: '100%', sm: '158px'},
              height: {xs: '200px', sm: '158px'},
            }}>
            <Media src={photo} title={address} />
          </Box>
          <Box padding={4} position="relative" width="100%">
            <Text fontSize="14px" weight="700" color="text.primary">
              <Truncate limit={60}>{address}</Truncate>
            </Text>
            <Text
              fontSize="11px"
              mt="6px"
              sx={{visibility: dateAvailable ? 'visible' : 'hidden'}}>
              Available: {dateAvailable}
            </Text>
            <Box
              as="span"
              padding="1px 8px"
              mt="6px"
              backgroundColor="#E1F6FC"
              sx={{
                textAlign: 'center',
                width: 'fit-content',
                minHeight: '20px',
                visibility: rentAmount ? 'visible' : 'hidden',
              }}>
              <Text fontSize="12px" color="primaryAlt.main">
                {rentAmount}
              </Text>
            </Box>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'flex-end',
                left: {xs: '0', sm: '16px'},
                bottom: {xs: '0', sm: '16px'},
                position: {xs: 'relative', sm: 'absolute'},
                width: {xs: '100%', sm: 'calc(100% - 32px)'},
              }}>
              <PropertyAttributes
                noOfBedrooms={bedrooms}
                noOfBathrooms={bathrooms}
                noOfCarparks={parkingSpaces}
                iconSize="18px"
                spacing={3}
                sx={{gap: 0, fontSize: '10px'}}
              />
              {onView && (
                <Box marginLeft="auto">
                  <Button
                    variant="contained"
                    color="primary"
                    size="small"
                    onClick={onView}>
                    <Text fontSize={12} weight="700">
                      Book a viewing
                    </Text>
                  </Button>
                </Box>
              )}
            </Box>
          </Box>
        </Box>
      </Paper>
    </StyledPropertyItem>
  );
}

PropertyCard.propTypes = {
  photo: PropTypes.string,
  address: PropTypes.string,
  rentAmount: PropTypes.string,
  dateAvailable: PropTypes.string,
  bedrooms: PropTypes.number,
  bathrooms: PropTypes.number,
  parkingSpaces: PropTypes.number,
  /**
   * View click handler
   */
  onView: PropTypes.oneOfType([PropTypes.func, PropTypes.instanceOf(null)]),
};

export default PropertyCard;
